/**
 * Format date untuk API (ISO 8601)
 * @param {string|Date} dateStr - Tanggal dalam string atau Date object
 * @returns {string|null} ISO string atau null jika invalid
 */
export const formatForAPI = dateStr => {
  if (!dateStr) return null;
  const date = new Date(dateStr);
  return isNaN(date.getTime()) ? null : date.toISOString();
};

export const formatForShortDateAPI = dateStr => {
  if (!dateStr) return null;
  const date = new Date(dateStr);
  return isNaN(date.getDate()) ? null : date.toISOString();
};

// export const formatForAPI = (dateStr) => {
//   if (!dateStr) return null;
//   const dates = new Date(dateStr);
//   const date = parse(dates, "yyyy-MM-dd HH:mm", new Date());
//   return isNaN(date.getTime()) ? null : date.toISOString();
// };

export const formatForDisplay = (isoString, options = {}) => {
  const { includeTime = true } = options;

  if (!isoString) return '';
  const date = new Date(isoString);
  if (isNaN(date.getTime())) return '';

  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();

  if (!includeTime) return `${day}/${month}/${year}`;

  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  return `${day}/${month}/${year} ${hours}:${minutes}`;
};

/**
 * Format date untuk input Flatpickr (object tanggal atau ISO string ke Date object)
 * @param {string|Date|undefined} date - Tanggal dari API
 * @returns {Date|undefined} Date object atau undefined jika invalid
 */
export const formatForFlatpickr = date => {
  if (!date) return undefined;
  const d = new Date(date);
  return isNaN(d.getTime()) ? undefined : d;
};
